var badgeNumb = 0;
export default {
    // 初始化
    initialize: ()=> {
        // 设备加载成功的时候 
        document.addEventListener("deviceready", ()=> {
            document.addEventListener("jpush.receiveRegistrationId", function (event) {
                // console.log("receiveRegistrationId" + JSON.stringify(event));
                // $("#registrationId").html(event.registrationId);
            }, false)
            // console.log("===[初始化极光推送]===");
            try {
                window.JPush.init();
                window.JPush.setDebugMode(true);
                if (device.platform != "Android") {
                    window.JPush.setApplicationIconBadgeNumber(0);
                }
            } catch (exception) {
                console.log('error', exception);
            }
        }, false);
        // 获取点击状态栏中的通知内容时
        // document.addEventListener("jpush.openNotification", onOpenNotificationM, false);
        // // 收到消息   
        // document.addEventListener("jpush.receiveNotification", onReceiveNotificationX, false);
        // // 获取自定义消息
        // document.addEventListener("jpush.receiveMessage", onReceiveMessageZ, false);
        // // 处理恢复事件
        // document.addEventListener("resume", onResumeS, false);
    },

    onOpenNotificationM: function (event, callback) {
        try {
            var alertContent;
            var extra = {};
            if (device.platform == "Android") {
                alertContent = event.alert;
                extra = event.extras.param ? JSON.parse(event.extras.param) : {};
            } else {
                alertContent = event.aps.alert;
            }

            badgeNumb = badgeNumb - 1;
            badgeNumb = badgeNumb <= 0 ? 0 : badgeNumb;
            window.JPush.setBadgeNumber(badgeNumb);
            callback && callback(alertContent, extra);
            // alert("请及时查看：" + alertContent);
        } catch (exception) {
            alert("JPushPlugin:onOpenNotificationM" + exception);
        }
    },

    onReceiveNotificationX: function (event) {
        try {
            var alertContent;
            if (device.platform == "Android") {
                alertContent = event.alert;
            } else {
                alertContent = event.aps.alert;
            }
            // $("#notificationResult").html(alertContent);

            badgeNumb = badgeNumb + 1;
            window.JPush.setBadgeNumber(badgeNumb);
        } catch (exception) {
            console.log(exception)
        }
    },

    onReceiveMessageZ: function (event) {
        try {
            var message;
            if (device.platform == "Android") {
                message = event.message;
            } else {
                message = event.content;
            }
            // $("#messageResult").html(message);

            badgeNumb = badgeNumb + 1;
            window.JPush.setBadgeNumber(badgeNumb);
        } catch (exception) {
            console.log("JPushPlugin:onReceiveMessageZ-->" + exception);
        }
    },

    onResumeS: function (event) {
        try {
            badgeNumb = 0
            window.JPush.setBadgeNumber(0);
        } catch (exception) {
            console.log("onResumeS-->" + exception);
        }
    },

    /**
     * 集成了 JPush SDK 的应用程序在第一次成功注册到 JPush 服务器时，JPush 服务器会给客户端返回一个唯一的该设备的标识 - RegistrationID。
     * 应用程序可以把此 RegistrationID 保存以自己的应用服务器上，然后就可以根据 RegistrationID 来向设备推送消息或者通知。
     */
    getRegistrationID: ()=> {
        window.JPush.getRegistrationID(onGetRegistrationID);
    },

    // 设置别名。注意这个接口是覆盖逻辑，而不是增量逻辑。即新的调用会覆盖之前的设置。
    // - sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
    // - alias: string
    //   - 每次调用设置有效的别名将覆盖之前的设置。
    //   - 有效的别名组成：字母（区分大小写）、数字、下划线、汉字、特殊字符@!#$&*+=.|。
    //   - 限制：alias 命名长度限制为 40 字节（判断长度需采用 UTF-8 编码）。
    setAlias: function (alias = '', sequence = 1) {
        window.JPush.setAlias({ sequence, alias },
            (result) => {
                console.log('setAlias', result)
                // var sequence = result.sequence
                // var alias = result.alias
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: setAlias', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    // 删除设备别名
    // - sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
    deleteAlias: function (sequence = 1) {
        window.JPush.deleteAlias({ sequence },
            (result) => {
                //   var sequence = result.sequence
            }, (error) => {
                var sequence = error.sequence;
                var errorCode = error.code;
                console.log('name: deleteAlias', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    // 获取设备别名
    // - sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
    getAlias: function (sequence = 1) {
        window.JPush.getAlias({ sequence },
            (result) => {
                var sequence = result.sequence
                var alias = result.alias
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: getAlias', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    /**
     * 设置标签。注意这个接口是覆盖逻辑，而不是增量逻辑。即新的调用会覆盖之前的设置。
     * sequence: number。用户自定义的操作序列号, 同操作结果一起返回，用来标识一次操作的唯一性。
     */
    setTags: function (tags = [], sequence = 1) {
        // alert("设置tage")
        try {
            window.JPush.setTags({ sequence, tags },
                (result) => {
                    //   var sequence = result.sequence
                    //   var tags = result.tags  // 数组类型
                }, (error) => {
                    var sequence = error.sequence;
                    var errorCode = error.code;
                    console.log('name: setTags', 'sequence', sequence, 'errorCode', errorCode)
                })
        } catch (exception) {
            console.log(exception)
        }
    },

    addTags: function (tags = [], sequence = 1) {
        window.JPush.addTags({ sequence, tags },
            (result) => {
                //   var sequence = result.sequence
                //   var tags = result.tags  // 数组类型
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: addTags', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    // 获取tage
    getAllTags: function (sequence = 1) {
        window.JPush.getAllTags({ sequence },
            (result) => {
                //   var sequence = result.sequence
                //   var tags = result.tags
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: getAllTags', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    // 清空tage
    cleanTags: function (sequence = 1) {
        window.JPush.cleanTags({ sequence },
            (result) => {
                // var sequence = result.sequence
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: cleanTags', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

    //删除指定标签。
    deleteTags: function (tags = [], sequence = 1) {
        window.JPush.deleteTags({ sequence, tags },
            (result) => {
                // var sequence = result.sequence
            }, (error) => {
                var sequence = error.sequence
                var errorCode = error.code
                console.log('name: deleteTags', 'sequence', sequence, 'errorCode', errorCode)
            })
    },

}



// WEBPACK FOOTER //
// ./src/box/jpush.js